import {
  AI_DRAFTED_FIELD_STEP,
  AiDraftedFieldStep,
} from 'models/MixpanelEvents';
import { SESSION_STORAGE_KEYS } from 'services/sessionStorageService';

export type ReportedFields = Record<string, boolean>;

// Wizard step index -> the step number the event reports. Only the first two steps
// carry AI-drafted fields, so every other index tracks nothing.
export const AI_DRAFTED_FIELD_STEPS: Record<number, AiDraftedFieldStep> = {
  0: AI_DRAFTED_FIELD_STEP.BUSINESS_INFO,
  1: AI_DRAFTED_FIELD_STEP.STATEMENT_OF_INFORMATION,
};

// One storage entry per listing, holding the drafted fields already reported on it -
// so a field is reported once for the whole browser session, not once per visit to
// the step, and a listing's fields never pile up in a shared blob.
export const getReportedFieldsStorageKey = (listingId: string) =>
  `${SESSION_STORAGE_KEYS.REPORTED_AI_DRAFTED_FIELD_EDITS}:${listingId}`;

// dirtyFields is keyed by full path - highlights[0], listingContact.email - while a
// drafted field is the property AI filled, so edits anywhere inside it report the
// root.
export const getRootFieldName = (fieldPath: string) =>
  fieldPath.split(/[.[]/)[0];
